import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Navimumbaicabservice() {



    const cardData = {
"keyword": "Navi Mumbai Cab Service",

"headingDescription":
  "Om Sai Cab offers reliable and comfortable Navi Mumbai Cab Service for travelers looking for safe, affordable, and convenient local and outstation taxi solutions. Whether you need airport transfers, daily commuting, business travel, family trips, sightseeing tours, or long-distance journeys, our cab service ensures a smooth and stress-free experience across Navi Mumbai and beyond. With experienced drivers familiar with all major routes, clean air-conditioned vehicles maintained for comfort, and transparent pricing with no hidden charges, we provide a dependable travel solution for every passenger. Our fleet includes sedans, SUVs, Innova cars, tempo travellers, and premium vehicles suitable for solo travelers, families, and groups.",

"topPlaces": [
  {
    "title": "Goa",
    "description": "Travel from Navi Mumbai to Goa, a popular destination known for its beaches, resorts, and vibrant culture."
  },
    {
    "title": "Pune",
    "description": "Travel from Navi Mumbai to Pune, a leading IT, education, and manufacturing hub in Maharashtra."
  },
   {
    "title": "Mahabaleshwar",
    "description": "Travel from Navi Mumbai to Mahabaleshwar, a beautiful hill station known for its viewpoints and strawberry farms."
  },

  {
    "title": "Lonavala",
    "description": "Travel from Navi Mumbai to Lonavala, a scenic hill station popular for weekend getaways and nature trails."
  },
 
  {
    "title": "Nashik",
    "description": "Travel from Navi Mumbai to Nashik, a major industrial city famous for vineyards and religious sites."
  },
  {
    "title": "Shirdi",
    "description": "Travel from Navi Mumbai to Shirdi, one of India's most visited pilgrimage destinations dedicated to Sai Baba."
  },
  
  {
    "title": "Aurangabad",
    "description": "Travel from Navi Mumbai to Aurangabad, a historic city and gateway to the Ajanta and Ellora Caves."
  },
  {
    "title": "Kolhapur",
    "description": "Travel from Navi Mumbai to Kolhapur, a cultural and commercial city known for temples, cuisine, and industries."
  },
  {
    "title": "Surat",
    "description": "Travel from Navi Mumbai to Surat, India's leading textile and diamond business hub."
  },
  {
    "title": "Ahmedabad",
    "description": "Travel from Navi Mumbai to Ahmedabad, a major commercial, industrial, and financial center in Gujarat."
  }
],



services: [
  {
    name: "Cabs Navi Mumbai",
    description: "Cabs Navi Mumbai service provides reliable transportation for travelers planning comfortable local and outstation travel across Navi Mumbai. Vehicles ensure smooth city and highway journeys suitable for tourism travel, airport transfers, business trips, and family outings. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby areas across Navi Mumbai. Flexible booking options allow convenient cab reservations."
  },
  {
    name: "Cabs in Navi Mumbai",
    description: "Cabs in Navi Mumbai service offers dependable transportation with comfortable vehicles for local and long-distance travel requirements. Vehicles ensure reliable city travel suitable for executive travel, tourism trips, family vacations, and airport transfers. Professional chauffeurs ensure safe driving and reliable pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and nearby locations across Navi Mumbai. Flexible booking options allow convenient cab reservations."
  },
  {
    name: "Kharghar Taxi Service",
    description: "Kharghar taxi service provides comfortable transportation for passengers planning local and outstation road journeys from Kharghar. Vehicles ensure smooth city and highway travel suitable for airport transfers, tourism travel, business trips, and family outings. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby locations across Kharghar. Flexible booking options allow convenient taxi reservations."
  },
  {
    name: "Navi Mumbai Taxi Service",
    description: "Navi Mumbai taxi service provides reliable transportation for travelers seeking comfortable local and outstation travel across Navi Mumbai. Vehicles ensure smooth road journeys suitable for airport transfers, tourism travel, executive trips, and family holidays. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby locations across Navi Mumbai. Flexible booking options allow convenient taxi service reservations."
  },
  {
    name: "Taxi Service in Vashi Navi Mumbai",
    description: "Taxi service in Vashi Navi Mumbai offers dependable transportation with comfortable vehicles for local and outstation travel. Vehicles ensure reliable city and highway journeys suitable for tourism travel, airport transfers, family outings, and business trips. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby locations across Vashi. Flexible booking options allow convenient taxi reservations."
  },
  {
    name: "Navi Mumbai Cab Service",
    description: "Navi Mumbai cab service provides premium transportation solutions for travelers planning smooth and comfortable road journeys. Vehicles ensure reliable city and highway travel suitable for tourism travel, airport transfers, executive trips, and family vacations. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby areas across Navi Mumbai. Flexible booking options allow convenient cab service reservations."
  },
  {
    name: "Navi Mumbai Cabs",
    description: "Navi Mumbai cabs service offers comfortable transportation for travelers requiring dependable local and outstation travel across Navi Mumbai. Vehicles ensure smooth road journeys suitable for airport transfers, tourism travel, family outings, and business travel. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby locations across Navi Mumbai. Flexible booking options allow convenient cab reservations."
  },
  {
    name: "Navi Mumbai Taxi Booking",
    description: "Navi Mumbai taxi booking service provides easy transportation reservations for travelers planning smooth road journeys across Navi Mumbai. Comfortable vehicles ensure reliable city and highway travel suitable for tourism travel, airport transfers, and executive trips. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby areas across Navi Mumbai. Flexible booking options allow convenient taxi booking reservations."
  },
  {
    name: "Navi Mumbai Local Cab Service",
    description: "Navi Mumbai local cab service provides reliable transportation for passengers planning comfortable city travel across Navi Mumbai. Vehicles ensure smooth local road journeys suitable for office travel, shopping trips, airport transfers, and family outings. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and nearby locations across Navi Mumbai. Flexible booking options allow convenient local cab reservations."
  },
  {
    name: "Navi Mumbai Outstation Cab Service",
    description: "Navi Mumbai outstation cab service provides dependable long-distance transportation for travelers planning comfortable intercity road journeys. Vehicles ensure smooth highway travel suitable for tourism trips, family vacations, executive travel, and sightseeing tours. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby locations across Navi Mumbai. Flexible booking options allow convenient outstation cab reservations."
  },
  {
    name: "Navi Mumbai Car Rental",
    description: "Navi Mumbai car rental service provides spacious and comfortable vehicles for travelers planning private local and outstation road travel. Vehicles ensure reliable city and highway journeys suitable for tourism travel, family vacations, business trips, and airport transfers. Professional chauffeurs ensure dependable pickup and smooth transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby areas across Navi Mumbai. Flexible booking options allow convenient car rental reservations."
  },
  {
    name: "Navi Mumbai Airport Cab Service",
    description: "Navi Mumbai Airport cab service provides direct airport transportation for travelers planning comfortable airport road journeys. Vehicles ensure smooth city and highway travel suitable for airport transfers, executive travel, tourism trips, and family vacations. Professional chauffeurs ensure timely pickup and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby airport locations across Navi Mumbai. Flexible booking options allow convenient airport cab reservations."
  },
  {
    name: "Navi Mumbai AC Cab Service",
    description: "Navi Mumbai AC cab service provides air-conditioned transportation for comfortable and relaxing local and outstation travel. Vehicles ensure cool and smooth road journeys suitable for tourism travel, airport transfers, business trips, and family outings. Professional chauffeurs ensure reliable pickup and safe transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby areas across Navi Mumbai. Flexible booking options allow convenient AC cab reservations."
  },
  {
    name: "Navi Mumbai Tourist Taxi Service",
    description: "Navi Mumbai tourist taxi service offers dependable transportation for tourists planning sightseeing tours and comfortable road travel. Vehicles ensure reliable local and highway journeys suitable for tourism trips, family vacations, beach visits, and nearby sightseeing travel. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from hotels, homes, railway stations, and nearby tourist locations across Navi Mumbai. Flexible booking options allow convenient tourist taxi reservations."
  },
  {
    name: "Best Navi Mumbai Cab Service",
    description: "Best Navi Mumbai cab service provides premium transportation with comfortable vehicles and experienced chauffeurs for smooth road journeys. Vehicles ensure reliable city and highway travel suitable for airport transfers, tourism travel, executive trips, and family vacations. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby locations across Navi Mumbai. Flexible booking options allow convenient premium cab reservations."
  },
  {
    name: "Cheap Navi Mumbai Taxi Service",
    description: "Cheap Navi Mumbai taxi service offers budget-friendly transportation for solo travelers, tourists, couples, and families traveling across Navi Mumbai. Comfortable vehicles ensure smooth and reliable road journeys suitable for local travel, airport transfers, and family outings. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby areas across Navi Mumbai. Flexible booking options allow convenient low-cost taxi reservations."
  },
  {
    name: "Online Navi Mumbai Cab Booking",
    description: "Online Navi Mumbai cab booking service provides quick and convenient transportation reservations for travelers planning smooth road journeys. Vehicles ensure reliable city and highway travel suitable for airport transfers, tourism trips, and executive travel. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby locations across Navi Mumbai. Flexible online booking options allow convenient cab reservations."
  },
  {
    name: "Navi Mumbai Cab Fare",
    description: "Navi Mumbai cab fare service provides affordable and transparent transportation pricing for travelers planning local and outstation road travel. Comfortable vehicles ensure smooth city and highway journeys suitable for airport transfers, tourism travel, and family outings. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby areas across Navi Mumbai. Flexible booking options allow convenient cab fare reservations."
  },
  {
    name: "Navi Mumbai Taxi Fare",
    description: "Navi Mumbai taxi fare service offers economical transportation pricing for travelers planning comfortable road journeys across Navi Mumbai. Vehicles ensure reliable city travel suitable for tourism travel, airport transfers, executive trips, and family vacations. Professional chauffeurs ensure punctual pickup and safe transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby locations across Navi Mumbai. Flexible booking options allow convenient taxi fare reservations."
  },
  {
    name: "Reliable Navi Mumbai Cab Service",
    description: "Reliable Navi Mumbai cab service provides dependable transportation solutions for travelers planning safe and smooth road journeys. Comfortable vehicles ensure reliable city and highway travel suitable for airport transfers, tourism travel, business trips, and family holidays. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby areas across Navi Mumbai. Flexible booking options allow convenient reliable cab reservations."
  },
  {
    name: "Affordable Navi Mumbai Taxi Booking",
    description: "Affordable Navi Mumbai taxi booking service offers budget-friendly transportation reservations for travelers planning economical local and outstation travel. Vehicles ensure smooth and reliable road journeys suitable for airport transfers, tourism travel, and family outings. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby locations across Navi Mumbai. Flexible booking options allow convenient affordable taxi reservations."
  },
  {
    name: "Premium Navi Mumbai Cab Service",
    description: "Premium Navi Mumbai cab service provides luxury transportation with spacious and comfortable vehicles for stylish road journeys. Vehicles ensure smooth city and highway travel suitable for executive travel, tourism trips, VIP transportation, and family holidays. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby airport locations across Navi Mumbai. Flexible booking options allow convenient premium cab reservations."
  },
  {
    name: "Trusted Navi Mumbai Cabs",
    description: "Trusted Navi Mumbai cabs service provides reliable transportation for travelers seeking safe and smooth local and outstation travel. Comfortable vehicles ensure dependable city and highway journeys suitable for tourism travel, airport transfers, and business trips. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby areas across Navi Mumbai. Flexible booking options allow convenient trusted cab reservations."
  },
  {
    name: "Navi Mumbai Innova Cab",
    description: "Navi Mumbai Innova cab service provides spacious transportation for families and groups planning comfortable local and outstation travel. Innova vehicles ensure smooth road journeys with comfortable seating and luggage capacity suitable for tourism travel and airport transfers. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby locations across Navi Mumbai. Flexible booking options allow convenient Innova cab reservations."
  },
  {
    name: "Navi Mumbai Innova Crysta Cab",
    description: "Navi Mumbai Innova Crysta cab service provides luxury transportation with premium interiors and spacious seating for comfortable road journeys. Innova Crysta vehicles are ideal for executive travel, tourism trips, airport transfers, and VIP transportation. Professional chauffeurs ensure punctual pickup and premium transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby areas across Navi Mumbai. Flexible booking options allow convenient Innova Crysta cab reservations."
  },
  {
    name: "Navi Mumbai Ertiga Cab",
    description: "Navi Mumbai Ertiga cab service offers affordable and spacious transportation for small families and groups planning comfortable road journeys. Ertiga vehicles ensure reliable city and highway travel suitable for tourism travel, airport transfers, and family outings. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby locations across Navi Mumbai. Flexible booking options allow convenient Ertiga cab reservations."
  },
  {
    name: "Navi Mumbai Swift Dzire Cab",
    description: "Navi Mumbai Swift Dzire cab service provides comfortable transportation for solo travelers, couples, and business passengers planning local and outstation travel. Swift Dzire vehicles ensure smooth road journeys suitable for airport transfers, tourism travel, and executive trips. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby areas across Navi Mumbai. Flexible booking options allow convenient Swift Dzire cab reservations."
  },
  {
    name: "Navi Mumbai Sedan Cab",
    description: "Navi Mumbai sedan cab service offers reliable transportation for travelers seeking comfortable city and highway road journeys. Sedan vehicles ensure smooth and safe travel suitable for tourism travel, airport transfers, executive travel, and family outings. Professional chauffeurs ensure dependable pickup and reliable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby locations across Navi Mumbai. Flexible booking options allow convenient sedan cab reservations."
  },
  {
    name: "Navi Mumbai SUV Cab",
    description: "Navi Mumbai SUV cab service provides spacious transportation for travelers seeking premium and comfortable road journeys across Navi Mumbai. SUV vehicles ensure reliable city and highway travel suitable for tourism travel, family vacations, airport transfers, and group travel. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby areas across Navi Mumbai. Flexible booking options allow convenient SUV cab reservations."
  },
  {
    name: "Navi Mumbai Kia Carens Cab",
    description: "Navi Mumbai Kia Carens cab service provides premium and spacious transportation for families and groups planning comfortable road journeys. Kia Carens vehicles ensure smooth city and highway travel suitable for airport transfers, tourism trips, and family vacations. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby locations across Navi Mumbai. Flexible booking options allow convenient Kia Carens cab reservations."
  },
  {
    name: "Navi Mumbai Luxury Car Rental",
    description: "Navi Mumbai luxury car rental service provides premium transportation with luxury vehicles suitable for stylish and comfortable travel experiences. Vehicles ensure smooth road journeys ideal for executive travel, VIP transportation, tourism trips, and family holidays. Professional chauffeurs ensure dependable pickup and premium transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby airport locations across Navi Mumbai. Flexible booking options allow convenient luxury car rental reservations."
  },
  {
    name: "Navi Mumbai Airport Cab",
    description: "Navi Mumbai Airport cab service provides direct airport transportation for travelers planning comfortable pickup and drop road journeys. Vehicles ensure smooth city and highway travel suitable for airport transfers, tourism trips, executive travel, and family vacations. Professional chauffeurs ensure timely pickup and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby airport locations across Navi Mumbai. Flexible booking options allow convenient airport cab reservations."
  }
],

tableData: [
  ["Cabs Navi Mumbai", "Cabs in Navi Mumbai"],
  ["Kharghar Taxi Service", "Navi Mumbai Taxi Service"],
  ["Taxi Service in Vashi Navi Mumbai", "Navi Mumbai Cab Service"],
  ["Navi Mumbai Cabs", "Navi Mumbai Taxi Booking"],
  ["Navi Mumbai Local Cab Service", "Navi Mumbai Outstation Cab Service"],
  ["Navi Mumbai Car Rental", "Navi Mumbai Airport Cab Service"],
  ["Navi Mumbai AC Cab Service", "Navi Mumbai Tourist Taxi Service"],
  ["Best Navi Mumbai Cab Service", "Cheap Navi Mumbai Taxi Service"],
  ["Online Navi Mumbai Cab Booking", "Navi Mumbai Cab Fare"],
  ["Navi Mumbai Taxi Fare", "Reliable Navi Mumbai Cab Service"],
  ["Affordable Navi Mumbai Taxi Booking", "Premium Navi Mumbai Cab Service"],
  ["Trusted Navi Mumbai Cabs", "Navi Mumbai Innova Cab"],
  ["Navi Mumbai Innova Crysta Cab", "Navi Mumbai Ertiga Cab"],
  ["Navi Mumbai Swift Dzire Cab", "Navi Mumbai Sedan Cab"],
  ["Navi Mumbai SUV Cab", "Navi Mumbai Kia Carens Cab"],
  ["Navi Mumbai Luxury Car Rental", "Navi Mumbai Airport Cab"]
],


whychoose: [
  {
    WhyChooseheading: "Reliable Navi Mumbai Cab Service",
    WhyChoosedescription: "Om Sai Cab Service provides reliable Navi Mumbai cab service with professional drivers, comfortable vehicles, and smooth travel for local rides, airport transfers, and outstation journeys."
  },
  {
    WhyChooseheading: "Affordable Navi Mumbai Taxi Fare",
    WhyChoosedescription: "Our Navi Mumbai taxi service offers affordable pricing with transparent fare details and no hidden charges for local and outstation travel bookings."
  },
  {
    WhyChooseheading: "24/7 Navi Mumbai Cab Availability",
    WhyChoosedescription: "Om Sai Cab Service operates 24 hours a day for Navi Mumbai cab bookings including airport transfers, corporate travel, family trips, and emergency transportation."
  },
  {
    WhyChooseheading: "Comfortable & Clean AC Cabs",
    WhyChoosedescription: "All Navi Mumbai taxis are fully air-conditioned, sanitized, spacious, and regularly maintained for smooth and comfortable travel experiences."
  },
  {
    WhyChooseheading: "Local & Outstation Taxi Booking Options",
    WhyChoosedescription: "Customers can book local Navi Mumbai taxi service, airport transfers, one-way cabs, round-trip travel, and customized outstation travel packages."
  },
  {
    WhyChooseheading: "Wide Range of Vehicle Choices",
    WhyChoosedescription: "Om Sai Cab Service offers sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers suitable for individuals, families, tourists, and group travel."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Navi Mumbai",
    WhyChoosedescription: "We provide convenient pickup service from Vashi, Nerul, Belapur, Panvel, Kharghar, Airoli, hotels, railway stations, offices, and all major Navi Mumbai areas."
  },
  {
    WhyChooseheading: "Experienced Drivers for City & Highway Routes",
    WhyChoosedescription: "Our experienced drivers are familiar with Navi Mumbai city roads, highways, airport routes, and nearby destinations to ensure safe and timely travel."
  }
]
};

const faqData = [
  {
    question: "What is Navi Mumbai cab service?",
    answer: "Navi Mumbai cab service provides comfortable taxi transportation for local travel, airport transfers, corporate rides, and outstation journeys."
  },
  {
    question: "Is Navi Mumbai cab service available 24 hours?",
    answer: "Yes, Om Sai Cab Service provides 24/7 Navi Mumbai taxi service."
  },
  {
    question: "Which vehicles are available for Navi Mumbai travel?",
    answer: "Customers can choose sedan taxis, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers."
  },
  {
    question: "Can I book one-way and round-trip cabs in Navi Mumbai?",
    answer: "Yes, one-way as well as round-trip Navi Mumbai cab bookings are available."
  },
  {
    question: "Do you provide airport pickup and drop service?",
    answer: "Yes, Om Sai Cab Service provides airport pickup and drop service for Mumbai Airport and Navi Mumbai Airport routes."
  },
  {
    question: "Are all Navi Mumbai taxis air-conditioned?",
    answer: "Yes, all taxis are fully air-conditioned and maintained for comfortable travel."
  },
  {
    question: "Can I book Navi Mumbai cab service online?",
    answer: "Yes, customers can easily book Navi Mumbai cab service online or through phone booking."
  },
  {
    question: "Do you provide cabs for family and corporate travel?",
    answer: "Yes, comfortable vehicles are available for family travel, business meetings, and corporate transportation."
  },
  {
    question: "Are Navi Mumbai cab fares transparent?",
    answer: "Yes, Om Sai Cab Service provides affordable and transparent pricing without hidden charges."
  },
  {
    question: "Is advance booking available for Navi Mumbai cab service?",
    answer: "Yes, advance booking is available and recommended during weekends, holidays, and peak travel hours."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Prashant Shinde",
    feedback: "Booked Navi Mumbai cab service with Om Sai Cab Service. Clean cab, polite driver, and very comfortable travel experience.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Patil",
    feedback: "Excellent Navi Mumbai taxi service with affordable pricing and timely pickup for our airport transfer.",
    rating: 5
  }
];
















    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai to Goa Cab", link: "Mumbai-to-Goa-Cab" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Goa Cab Booking", link: "Mumbai-to-Goa-Cab-Booking" },
        { place: "/images/keyword/3.jpg", text: "Navi Mumbai to Goa Cab Service", link: "Navi-Mumbai-to-Goa-Cab-Service" },
        { place: "/images/keyword/4.jpg", text: "Mumbai Airport to Goa Cab", link: "Mumbai-Airport-to-Goa-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Goa Cab Service", link: "Mumbai-to-Goa-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Best Mumbai to Goa Cab Service", link: "Best-Mumbai-to-Goa-Cab-Service" },
        { place: "/images/keyword/7.jpg", text: "Thane to Goa Cabs", link: "Thane-to-Goa-Cabs" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Goa Innova Crysta Cab", link: "Mumbai-to-Goa-Innova-Crysta-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Goa One Way Cab", link: "Mumbai-to-Goa-One-Way-Cab" },
        { place: "/images/keyword/10.jpg", text: "Goa Cabs Service", link: "Goa-Cabs-Service" },
        { place: "/images/keyword/11.jpg", text: "Goa to Mumbai Cab", link: "Goa-to-Mumbai-Cab" },
        { place: "/images/keyword/12.jpg", text: "Goa to Navi Mumbai Cab", link: "Goa-to-Navi-Mumbai-Cab" },
        { place: "/images/keyword/13.jpg", text: "Goa to Mumbai Airport Cab", link: "Goa-to-Mumbai-Airport-Cab" },
        { place: "/images/keyword/14.jpg", text: "Goa to Mumbai One Way Cab", link: "Goa-to-Mumbai-One-Way-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/16.jpg", text: "Lonavala to Mumbai Cab", link: "Lonavala-to-Mumbai-Cab" },
        { place: "/images/keyword/17.jpg", text: "Best Lonavala to Navi Mumbai Cab", link: "Best-Lonavala-to-Navi-Mumbai-Cab" },
        { place: "/images/keyword/18.jpg", text: "Navi Mumbai Airport Cab", link: "Navi-Mumbai-Airport-Cab" },
        { place: "/images/keyword/19.jpg", text: "Navi Mumbai Cab Service", link: "Navi-Mumbai-Cab-Service" },
        { place: "/images/keyword/20.jpg", text: "Kharghar Taxi Services", link: "Kharghar-Taxi-Services" },
        { place: "/images/keyword/21.jpg", text: "Mumbai Airport Cabs", link: "Mumbai-Airport-Cabs" },
        { place: "/images/keyword/22.jpg", text: "Mumbai Cab Service", link: "Mumbai-Cab-Service" },
        { place: "/images/keyword/23.jpg", text: "Mumbai Online Cab Service", link: "Mumbai-Online-Cab-Service" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/25.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/26.jpg", text: "Innova Crysta On Rent in Mumbai", link: "Innova-Crysta-On-Rent-in-Mumbai" },
    ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Navi Mumbai Cab Service",
  "image": "http://www.omsaicabservice.com/assets/images/navi-mumbai-cab-service.jpg",
  "description": "Book Navi Mumbai cab service with Om Sai Cab Service for local, airport, and outstation travel. Affordable AC Sedan, SUV, and luxury taxi services available in Vashi, Kharghar, and across Navi Mumbai with 24x7 support.",
  "brand": {
    "@type": "Brand",
    "name": "Om Sai Cab Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "http://www.omsaicabservice.com/navi-mumbai-cab-service"
  }
};





    return (
        <div>

<Helmet>
  <title>
    Navi Mumbai Cab Service | Local, Airport & Outstation Taxi | +91 9594849797
  </title>

  <meta
    name="description"
    content="Book Navi Mumbai cab service for local travel, airport transfers, and outstation trips. Reliable taxi service in Vashi, Kharghar, and all Navi Mumbai areas with Sedan, SUV, and AC cab options available 24x7."
  />

  <meta
    name="keywords"
    content="cabs navi mumbai, cabs in navi mumbai, kharghar taxi service, navi mumbai taxi service, taxi service in vashi navi mumbai, Navi Mumbai Cab Service, Navi Mumbai Cabs, Navi Mumbai Taxi Service, Navi Mumbai Taxi Booking, Navi Mumbai Local Cab Service, Navi Mumbai Outstation Cab Service, Navi Mumbai Car Rental, Navi Mumbai Airport Cab Service, Navi Mumbai AC Cab Service, Navi Mumbai Tourist Taxi Service, Best Navi Mumbai Cab Service, Cheap Navi Mumbai Taxi Service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div className="breadcrumb-bar">
                <div className="container">
                    <div className="row align-items-center text-center">
                        <div className="col-md-12 col-12">
                            <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/19.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FFCC00', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Om Sai Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Om Sai Cab</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Om Sai Cab </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                             <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919594849797" className="pc-call">+91 9594849797</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919594849797"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919594849797" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@omsaicabservice.com" className="pc-email">
                                            booking@omsaicabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Om Sai Cab Service</strong><br />
                                            Shree Vishal CHS Ltd., Plot No.17,
                                            Sector 18, Kopar Khairane, Navi Mumbai,
                                            Maharashtra- India - 400709
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Navimumbaicabservice;